"use client";

import NavSearchTrigger from "@/components/nav/NavSearchTrigger";
import { NAV_COLUMN_WIDTH } from "@/components/nav/nav-styles";
import { cn } from "@/lib/utils";

/**
 * Search in the navy top bar: a white field, the one thing on the bar that
 * looks typeable. While search is `open` the field becomes the input, which
 * NavTopBar lays over the results, as wide as their pane, the way Sabine's
 * header sits over her chat; the row keeps that width so what follows it in
 * the bar sits beside the input. `buttonRef` reaches the trigger, for the
 * shortcut tour and for focus to return to when the search is dismissed.
 * `hidden` keeps it mounted while Sabine's chat has the bar.
 */
export default function NavSearchRow({
  open,
  hidden = false,
  buttonRef,
  onOpen,
}) {
  return (
    <div
      className={cn(
        "flex",
        open ? cn("shrink-0", NAV_COLUMN_WIDTH) : "min-w-0 max-w-sm flex-1",
        hidden && "hidden",
      )}
    >
      {!open && <NavSearchTrigger buttonRef={buttonRef} onClick={onOpen} />}
    </div>
  );
}
